import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { apiURL } from "../config/config";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false); // ✅ เพิ่มบรรทัดนี้
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ ปิด dark mode เสมอในหน้า public
  useEffect(() => {
    document.documentElement.classList.remove("dark");
  }, []);

  // ✅ ตรวจ token จาก URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tokenFromUrl = params.get("token");
    if (tokenFromUrl) {
      setToken(tokenFromUrl);
    } else {
      toast.error("Invalid or expired reset token.");
      navigate("/login");
    }
  }, [location, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error("Passwords do not match ❌");
      return;
    }

    setLoading(true); // ✅ เริ่มโหลด

    try {
      const response = await axios.post(`${apiURL}auth/reset-password`, {
        resetToken: token,
        newPassword: password,
      });
      toast.success(response.data.message || "Password reset successfully ✅");
      navigate("/login");
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to reset password. Try again."
      );
    } finally {
      setLoading(false); // ✅ โหลดเสร็จ
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-100 via-white to-indigo-200 relative overflow-hidden">
      {/* 💫 Soft glow background */}
      <div className="absolute inset-0 flex justify-center items-center">
        <div className="w-[420px] h-[420px] bg-indigo-400/20 rounded-full blur-3xl animate-pulse" />
      </div>

      {/* 🪞 Glassmorphism Card */}
      <div className="relative backdrop-blur-2xl bg-white/70 border border-white/40 rounded-3xl shadow-lg w-full max-w-md p-8 sm:p-10 transition-all duration-300">
        {/* ✅ Logo */}
        <div className="flex justify-center mb-6">
          <img
            src="/optx-icon.png"
            alt="OPTX Logo"
            className="w-20 h-20 object-contain drop-shadow-md"
          />
        </div>

        {/* ✅ Header */}
        <h1 className="text-2xl font-bold text-center text-gray-800 mb-2">
          Reset Your Password
        </h1>
        <p className="text-center text-sm text-gray-600 mb-6">
          Enter and confirm your new password below to access your account again.
        </p>

        {/* ✅ Form */}
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              New Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter new password"
              className="w-full px-4 py-2 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white/60 text-gray-800 placeholder-gray-400 transition"
            />
          </div>

          <div>
            <label
              htmlFor="confirmPassword"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Confirm Password
            </label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              placeholder="Confirm new password"
              className="w-full px-4 py-2 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white/60 text-gray-800 placeholder-gray-400 transition"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full py-2 rounded-xl font-semibold text-white bg-gradient-to-r from-indigo-600 to-blue-500 hover:opacity-90 transition-all duration-300 shadow-md hover:shadow-lg ${
              loading ? "opacity-70 cursor-not-allowed" : ""
            }`}
          >
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </form>

        {/* ✅ Footer */}
        <div className="mt-4 text-center">
          <button
            onClick={() => navigate("/login")}
            className="text-sm text-indigo-500 hover:text-indigo-600 transition focus:outline-none"
          >
            ← Back to Login
          </button>
        </div>

        <p className="text-[11px] text-center text-gray-400 mt-6">
          © {new Date().getFullYear()} OPTX • All rights reserved
        </p>
      </div>
    </div>
  );
};

export default ResetPassword;
